// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleBindingRequestModuleVersion } from './moduleBindingRequestModuleVersion';

/**
 * Module binding used inside SlotBindingRequest.
 */
export interface ModuleBindingRequest {
  moduleId: string;
  /** Concrete module version or any */
  moduleVersion?: ModuleBindingRequestModuleVersion;
}
